import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import type {
  FeaturePageRenderModel,
  ResolvedFeaturePageBlock,
} from "@garimpa/api/featurePages/types";

export function SourcesBlock({
  block,
  sources,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "sources" }>;
  sources: FeaturePageRenderModel["sources"];
}) {
  if (!sources.length) return null;
  return (
    <FeaturePageSection
      block={block}
      resolvedBackground={block.resolvedBackground}
      className="py-10 md:py-14"
      innerClassName="max-w-5xl"
    >
      {block.heading ? (
        <h2 id={`${block.id}-heading`} className="mb-6 text-center text-2xl font-bold">
          {block.heading}
        </h2>
      ) : null}
      <ol className="grid gap-2 text-sm text-muted-foreground">
        {sources.map((source, index) => (
          <li
            key={source.id}
            id={`source-${source.id}`}
            className="grid scroll-mt-40 grid-cols-[auto_1fr] gap-3 rounded-xl border border-border/70 bg-card/50 p-3 transition-colors target:border-primary/70 target:bg-primary/5"
          >
            <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-bold text-primary">
              {index + 1}
            </span>
            <div>
              <a
                href={source.url}
                rel="noreferrer"
                className="font-semibold text-foreground hover:text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                {source.title}
              </a>
              <span>
                {" "}
                — {source.publisher},{" "}
                <time dateTime={source.retrievedAt}>{source.retrievedAt}</time>
              </span>
              {source.note ? <p className="mt-1.5 leading-relaxed">{source.note}</p> : null}
            </div>
          </li>
        ))}
      </ol>
    </FeaturePageSection>
  );
}
